import React from 'react';

import img1 from '../../assets/imgs/footer-img1.png';

export default function AppFooter() {
    return (
        <div className="flex justify-center text-[#666666]  text-[12px]">
            <div className="flex flex-col min-h-[100px] bg-slate-50 py-[24px] px-[40px]">
                <p className='mb-[24px] text-center'>
                    网上有害信息举报专区 涉未成年人等不良信息举报邮箱：
                    17361295293@163.com
                </p>

                <div className="flex justify-between text-[10px] gap-[18px]">
                    <p>
                        四川光启卓瑞科技有限公司&nbsp;
                        <a
                            data-v-233438f9=""
                            href="https://tsm.miit.gov.cn/dxxzsp/xkz/xkzgl/resource/qiyesearch.jsp?num=%E5%B7%9DB2-20251428&amp;type=xuke"
                            target="_blank"
                            rel="noopener noreferrer"
                        >
                            经营许可证编号川B2-20251428
                        </a>
                    </p>
                    <a
                        data-v-233438f9=""
                        href="https://beian.miit.gov.cn/#/Integrated/index"
                        target="_blank"
                        rel="noopener noreferrer"
                    >
                        蜀ICP备2025134544号-1
                    </a>
                    <span>Copyright © 2025.光启卓瑞 All rights reserved.</span>
                    <a
                        href="http://scpiyao.org.cn"
                        target="_blank"
                        rel="noreferrer"
                    >
                        <img
                            className="w-[90px] h-[22px]"
                            src={img1}
                            alt="img"
                        />
                    </a>
                </div>
            </div>
        </div>
    );
}
